export default {
  name: 'mCareIntegrationDailyCareUpdates',
  props: {
    settings: null,
    arecheckedesdisabled: Boolean,
    facility: null,
  },
  computed: {
    isFacilityHasCareAPI() {
      return this.$store.state.facilityModule.isFacilityHasCareAPI;
    },
    dailyCareCategory: {
      get() {
        return (
          (this.facility.featureMCareDailyCareUpdates ?? true) &&
          (this.facility.isCarePlan ?? true) &&
          (this.facility.isEnableCareTab ?? true) &&
          (this.facility.isCareSummary ?? true) &&
          (this.facility.isDailyPlan ?? true) &&
          (this.facility.isDailyCare ?? true) &&
          (this.facility.isEnabledSharedNotesToMCare ?? true)
        );
      }
    },
  },
  methods: {
    dailyCareCategoryUpdate(value) {
      this.facility.featureMCareDailyCareUpdates = value;
      this.facility.isCarePlan = value;
      this.facility.isEnableCareTab = value;
      this.facility.isCareSummary = value;
      this.facility.isDailyPlan = value;
      this.facility.isDailyCare = value;
      this.facility.isEnabledSharedNotesToMCare = value;
    },
  }
}